import React from 'react'
import { withRouter } from 'react-router-dom'
import { view } from 'react-easy-state'
import { Row, Col, Tooltip } from 'antd'

const PapersList = (props) => {

  const { papers } = props

  const paperColSpans = {
    xs: { span: 24, },
    sm: { span: 8 },
    md: { span: 6 },
  }

  const handleCardClick = (paperId) => {
    props.history.push(`/papers/${paperId}`)
  }

  return (
    <div className="course-list">
      {papers.length > 0 && <h3 style={{ marginTop: 30 }}>All Test Papers</h3>}
      <Row gutter={20}>
      {
        papers.map(paper =>
          <Col {...paperColSpans} className="m-t-20">
            <div className="course-item-card" onClick={() => handleCardClick(paper.id)}>
              <div className="course-image"><img src={paper.image_url} alt={paper.name} /></div>
              <div className="course-info">
                <Tooltip placement="top" title={paper.name} arrowPointAtCenter>
                  <div className="course-title">{paper.name}</div>
                </Tooltip>
              </div>
            </div>
          </Col>
        )
      }

      </Row>
    </div>
  )

}

export default withRouter(view(PapersList))
